import { Box, Image } from "@chakra-ui/react";

import logoLight from "../brand/logo-horizontal.svg";
import logoDark from "../brand/logo-horizontal-escuro.svg";
import symbolLight from "../brand/simbolo.svg";
import symbolDark from "../brand/simbolo-branco.svg";

const SOURCES = {
  horizontal: { light: logoLight, dark: logoDark },
  symbol: { light: symbolLight, dark: symbolDark },
};

// Logo oficial (docs/marca/logo). As duas versões ficam no DOM e o tema decide qual aparece,
// igual aos tokens semânticos — sem piscar a versão errada antes do color mode carregar.
export default function BrandLogo({ variant = "horizontal", h = "24px", ...rest }) {
  const src = SOURCES[variant] ?? SOURCES.horizontal;
  return (
    <Box display="inline-flex" flexShrink={0} {...rest}>
      <Image src={src.light} alt="MedStation" h={h} w="auto" _dark={{ display: "none" }} />
      <Image src={src.dark} alt="MedStation" h={h} w="auto" display="none" _dark={{ display: "block" }} />
    </Box>
  );
}
